import { faArrowsTurnToDots } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/utils/routes';
import { getRouteURI, getUuid } from 'src/utils/url';

const ProductionChangeButton = ({ runUri }) => {
  return (
    <Link
      to={getRouteURI(routes.productionChange, {
        uuid: getUuid(runUri),
      })}
    >
      <button type='button' className='button button--primary'>
        <FontAwesomeIcon icon={faArrowsTurnToDots} className='button__icon' />
        Production Change
      </button>
    </Link>
  );
};

ProductionChangeButton.propTypes = {
  runUri: PropTypes.string.isRequired,
};

export default ProductionChangeButton;
